module.exports = __webpack_public_path__ + "img/back_1.867004a2.png";